import { MutableRefObject } from 'react';
import { Board, Player, EvmAddress, PlayerLookupTable } from '../utils/Primitives';



export function storePlayerEns(props: { boardRef: MutableRefObject<Board>, address: EvmAddress, ens: string }) {
    const { boardRef, address, ens } = props;
    const playerStore = boardRef.current.playerStore as PlayerLookupTable;

    // Check if the player exists
    let player = playerStore[address];

    if (player) {
        // Update ens if it is different or not present
        if (player.ens !== ens) {
            player.ens = ens;
        }
    } else {
        // Initialize a new Player object if no record is found
        playerStore[address] = { address: address, ens: ens };
    }
}

// Function to store a player in the playerStore
export function storePlayer(props: { boardRef: MutableRefObject<Board>, player: Player }) {
    const { boardRef, player } = props;
    const playerStore = boardRef.current.playerStore as PlayerLookupTable;
    playerStore[player.address] = player;
}

// Function to fetch a player from the playerStore
export function fetchPlayer(props: { boardRef: MutableRefObject<Board>, address: EvmAddress }): Player | null {
    const { boardRef, address } = props;
    const playerStore = boardRef.current.playerStore as PlayerLookupTable;
    return playerStore[address] || null;
}
